import React, { createContext, useContext } from 'react';
import type { EditorHost } from '../types/public';

const EditorHostContext = createContext<EditorHost>('creativity');

export const EditorHostProvider: React.FC<{ host?: EditorHost; children: React.ReactNode }> = ({
  host = 'creativity',
  children
}) => <EditorHostContext.Provider value={host}>{children}</EditorHostContext.Provider>;

export const useEditorHost = (): EditorHost => useContext(EditorHostContext);
